export const patientProfileKeys = {
  base: ["patientProfile"] as const,
  details: () => [...patientProfileKeys.base, "details"] as const,
} as const;
